import profile from './images/png/profile.png';

const Png = {
      profile,
}

export default Png;